<div class="border-solid border-[2px] border-platform rounded-lg p-3 my-1">
  @if (draw(); as draw) {
    <div class="flex flex-col sm:flex-row sm:justify-between sm:place-items-center">
      <div class="flex flex-col justify-center justify-self-start my-1.5 sm:mr-3">
        <div class="font-semibold text-xl">{{ draw.displayName }}</div>
        <div class="text-sm">
          @switch (draw.state) {
            @case (DrawState.Created) {
              <div class="text-gray-600">Erstellt</div>
            }
            @case (DrawState.RegistrationOpen) {
              @if (draw.registration?.state == RegistrationState.Submitted) {
                <div class="text-platform-600">Registrierung abgegeben</div>
              } @else {
                <div class="text-green-600">Registrierung möglich</div>
              }
            }
            @case (DrawState.RegistrationComplete) {
              <div class="text-yellow-600">Losung läuft</div>
            }
            @case (DrawState.Drawn) {
              <div class="text-platform-600">Gelost 🎉</div>
            }
            @case (DrawState.Completed) {
              <div class="text-gray-600">Beendet</div>
            }
            @case (DrawState.Cancelled) {
              <div class="text-red-600">Abgebrochen</div>
            }
            @default {
              <div>-</div>
            }
          }
        </div>
      </div>
      <div class="flex ml-auto place-items-center justify-self-end my-1.5">
        <ng-content />
      </div>
    </div>
  }
</div>
